import { logEvent, logException } from '../services/analytics';

// User interaction events
export const trackButtonClick = (buttonName: string, location: string) => {
  logEvent('UI Interaction', 'Button Click', `${buttonName} - ${location}`);
};

export const trackFormSubmission = (formName: string, success: boolean) => {
  logEvent('Form', 'Submission', formName, success ? 1 : 0);
};

export const trackFeatureUsage = (featureName: string, details?: string) => {
  logEvent('Feature', 'Usage', `${featureName}${details ? ` - ${details}` : ''}`);
};

// Music-related events
export const trackSongPlay = (songTitle: string, artist: string, service: string) => {
  logEvent('Music', 'Play', `${songTitle} - ${artist} (${service})`);
};

export const trackLyricsView = (songTitle: string, artist: string) => {
  logEvent('Lyrics', 'View', `${songTitle} - ${artist}`);
};

// Error tracking
export const trackError = (errorType: string, errorMessage: string, isFatal = false) => {
  logException(`${errorType}: ${errorMessage}`, isFatal);
};

// Authentication events
export const trackAuthEvent = (eventType: 'Login' | 'Logout' | 'Signup' | 'PasswordReset', method: string) => {
  logEvent('Authentication', eventType, method);
};

// Subscription events
export const trackSubscriptionEvent = (eventType: string, plan: string) => {
  logEvent('Subscription', eventType, plan);
}; 